import { render } from "./TextLinkRenderer.vue?vue&type=template&id=8bfeb39a&scoped=true"
import script from "./TextLinkRenderer.vue?vue&type=script&lang=js"
export * from "./TextLinkRenderer.vue?vue&type=script&lang=js"

import "./TextLinkRenderer.vue?vue&type=style&index=0&id=8bfeb39a&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bfeb39a"]])

export default __exports__